// 保存データの形（getSaveText・makeCharactor と同じ）（2026-10-21 に app.js から分けた。2026-10-23 に中身へ）
import { C, blankLine, catByKey } from './model.js';
import { conf } from '../config.js';
import { keyOf } from './util.js';
import { findPart } from './data.js';
import { renderAll } from './render.js';
import { emit } from './events.js';
import { unzip } from './zlib.js';
import type { PartState, SaveData } from '../types.js';

// ---- 保存データ（getSaveText・makeCharactor と同じ形） ----
export const FIELDS: (keyof PartState)[] = ['parts', 'col', 'from', 'to', 'rev', 'tx', 'ty', 'scale', 'lfrom', 'lto', 'rfrom', 'rto', 'ptn', 'prev', 'ptnmode', 'rotate', 'opacity'];
// データの SPLIT（左右に分けたカテゴリ）: 前の行（eyelight など）を、分けた先のどれも無い保存データだけ、分けた先の全部に写す（同じ値。両目に同じハイライト）。
// 左・右だけの色（lfrom・rfrom）はそのまま写す（分けたカテゴリは左右の色を使わない。DRESSUP2 はクラシック版にも左右の色を付けるボタンが無く、
// 前の保存データにふつうは入っていない。2026-10-28）
function splitLines(lines: string[]): string[] {
  const split = C.data.SPLIT;
  if (!split) return lines;
  const has: Record<string, true> = {};
  lines.forEach((line) => { has[line.split(',')[0]] = true; });
  const out: string[] = [];
  lines.forEach((line) => {
    const key = line.split(',')[0], to = split[key];
    if (to && !to.some((k) => has[k])) to.forEach((k) => out.push(k + line.slice(key.length)));
    else out.push(line);
  });
  return out;
}
export function applySave(save: SaveData) {
  C.state = {};
  const seen: Record<string, boolean> = {};
  splitLines(save.c || []).forEach((line) => {
    const cols = line.split(','), key = cols[0];
    if (!catByKey[key] || seen[key]) return; // 無いカテゴリ・2回目以降の行は読まない（エンジンと同じ）
    seen[key] = true;
    const st = blankLine();
    FIELDS.forEach((f, i) => { if (cols.length > i + 1 && cols[i + 1] !== '') (st as unknown as Record<string, unknown>)[f] = cols[i + 1]; });
    if (!findPart(catByKey[key], st.parts)) return;
    st.parts = Number(st.parts);
    C.state[key] = st;
  });
  if (save.n && save.n.length >= 2) C.name = [decodeURIComponent(save.n[0] || ''), save.n[1]];
  renderAll('load');
  emit('applied');
}
export function saveObject(): SaveData {
  // レイヤーの並び（DOM の順）で、カテゴリの先頭レイヤーのところに1行
  const c: string[] = [];
  C.data.LAYER.forEach((layer) => {
    C.cats.forEach((cat) => {
      const key = keyOf(cat), st = C.state[key];
      if (cat.LAYER[0] !== layer || !st || st.parts == null) return;
      c.push(key + ',' + FIELDS.map((f) => st[f]).join(',') + ',');
    });
  });
  return { v: '1.0', n: [encodeURIComponent(C.name[0]), C.name[1]], c: c };
}
// localStorage の保存データ（圧縮して URL エンコード）を読む（Promise。無い・壊れているときは null）
export function readStored(key: string): Promise<SaveData | null> {
  let v = null;
  try { v = localStorage.getItem(key); } catch (e) {}
  if (!v) return Promise.resolve(null);
  return Promise.resolve().then(() => unzip(decodeURIComponent(v))).then((t) => JSON.parse(t), () => null).catch(() => null);
}
// はじめのキャラ（作りかけが無いとき）: メーカーの設定 defaultPreset（プリセットの番号。DRESSUP は 6＝デフォD、ユーザー判断 2026-10-20）。
// 無ければデータの先頭（最終保存の枠。空なら次の行。CHOCO はデフォキャラ A）
export const DEFAULT_PRESET = conf('defaultPreset', null);
export function defaultSave(): SaveData {
  if (DEFAULT_PRESET != null) {
    const pick = C.data.CHARA.filter((r) => Number(r[0]) === Number(DEFAULT_PRESET) && r[3])[0];
    if (pick) return JSON.parse(pick[3]);
  }
  const chara = C.data.CHARA[0][3] ? C.data.CHARA[0] : C.data.CHARA[1];
  return JSON.parse(chara[3]);
}
